import axios from "axios";

const URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:5000";

const axiosInstance = axios.create({
  baseURL: URL,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

export default axiosInstance; 
